import request from '@/utils/request'

// 获取费用配置列表
export function listFeeConfigs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeConfig.listFeeConfigs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询楼栋列表
export function queryFloors(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/floor.queryFloors',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询房屋列表
export function queryRooms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/room.queryRooms',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存房屋创建费用 --
// export function saveRoomCreatePayFee(data) {
//   return new Promise((resolve, reject) => {
//     request({
//       url: '/fee.roomCreatePayFee',
//       method: 'post',
//       data
//     }).then(response => {
//       const res = response.data
//       resolve(res)
//     }).catch(error => {
//       reject(error)
//     })
//   })
// }
// 保存房屋创建费用
export function saveRoomCreatePayFee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.batchSaveRoomCreateFee',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}